var account = "Reikningur";
var accountSettings = "Stillingar reiknings";
var charging = "Hleðsla";
var contactInfo = "Samskiptaupplýsingar";
var dashboard = "Stjórnborð";
var home = "Heim";
var myProducts = "Mínar vörur";
var orderHistory = "Pöntunarsaga";
var paymentMethod = "Greiðslumáti";
var profileSettings = "Prófílstillingar";
var referAndEarn = "Sendu boð og aflaðu";
var signOut = "Skrá út";
var is_IS = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, is_IS as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
